module.exports = __webpack_public_path__ + "static/media/BuiltSmartIcon.c6cf435d.svg";